let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6TNAX")).then(() => parcelRequire('d0vV5'));